// imports
import $ from "jquery";
import { Loader } from "./loader";
import { MostVisitedService } from "../services/mostVisitedService";
import { ILinkItem, IVisitedLinkItem } from "../dto/ILinkItem";


// globals
const service = new MostVisitedService();
let mostVisited: ILinkItem[];

export function initialize(): void {
    $(".js-load-latestvisited").on("click", onShowLatestVisited);
}

function onShowLatestVisited(event: any, params: any): void {
    $(".pILatestVisited").addClass("selectedItem").show();
    $("#heromenu_latestvisited").addClass("selectedItem").attr("aria-expanded", "true");
  
    $(".pIMyFavorites").removeClass("selectedItem").hide();
    $(".pIMyEducations").removeClass("selectedItem").hide();

    $("#heromenu_myfavourites").removeClass("selectedItem").attr("aria-expanded", "false");
    $("#heromenu_myeducations").removeClass("selectedItem").attr("aria-expanded", "false");

    $(".hero-menu__header-list").animate({ scrollLeft: $(".hero-menu__header-list")[0].scrollWidth }, 500);

    loadData();
}

function loadData(): void {
  const $container = $("#hero_latestvisited");
  const $noContentMsg = $container.find(".js-no-content-msg:first");
  const $loader = Loader.create();

  $noContentMsg.replaceWith($loader);

  service.getMostVisited(
    (data) => {
      mostVisited = data;

      if (!data.length) {
        $loader.replaceWith($noContentMsg);
        return;
      }
      populateData(data, $container, $loader);
    },
    () => {
      $loader.replaceWith($noContentMsg);
      alert("Tillfälligt fel: Kan inte hämta senast besökta");
    }
  );
}

function populateData(data: any, $container: any, $loader: any): void {
  const $wrapper = generateWrapper();

  for (let i = 0; i < data.length; i++) {
    if(i < 10){
      const $item = generateItem(data[i]);
      $wrapper.append($item);
    }
  }

  $loader.replaceWith($wrapper);
}

export function formatDate(input: string): string {
  const inputDate = new Date(input);
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);

  if (isToday(inputDate)) {
      let formattedDate = '';
      const diffInMilliseconds = today.getTime() - inputDate.getTime();
      const diffInHours = Math.floor(diffInMilliseconds / (1000 * 60 * 60));
      if (diffInHours < 1) {
          const diffInMinutes = Math.floor(diffInMilliseconds / (1000 * 60));
          if (diffInMinutes < 1) {
              formattedDate = "nyss";
          } else { 
              formattedDate = diffInMinutes + "m sedan";
          }
      } else { 
          formattedDate = diffInHours + "h sedan";
      }
      return formattedDate;
  } else if (isYesterday(inputDate)) {
      return "igår";
  } else {
      const options = { day: "numeric", month: "short" };
      const formattedDate = inputDate.toLocaleDateString("sv-SE", options)
                            .toLowerCase()
                            .split(' ')
                            .map(part => part.slice(0, 3))
                            .join(' ');
      return formattedDate;
  }
}

function isToday(date: Date): boolean {
  const today = new Date();
  return date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear();
}

function isYesterday(date: Date): boolean {
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  return date.getDate() === yesterday.getDate() &&
      date.getMonth() === yesterday.getMonth() &&
      date.getFullYear() === yesterday.getFullYear();
}

function generateWrapper(): any {
  return $(
    `<ul class="hero-menucontent__list"></ul>`
  );
}

function generateItem(item: IVisitedLinkItem): any {
  return $(`
        <li class="hero-menucontent__list-item">
            <a class="hero-menucontent__list-item-link" href="${item.linkItem.url}">
              <div class="top">
                <div>
                    ${item.documentMetaType ? (
                        `<span class="tag">${item.documentMetaType}</span>`
                    ) : ''}
                </div>
                ${item.lastVisitedDate ? (
                  `<span class="date">${formatDate(item.lastVisitedDate)}</div>`
                ) : ''}
              </div>
              <div class="bottom">
                <div class="notifications__link-item">
                    <span class="notification__header-title">${item.linkItem.text}</span>
                </div>
              </div>
            </a>
        </li>
    `);
}

